export const MODAL_ANIMATION_DURATION = 0.25;
export const MODAL_CONTAINER_ANIMATION_DURATION = 0.25;
